import { render, staticRenderFns } from "./init.vue?vue&type=template&id=e230ed44&"
import script from "./init.vue?vue&type=script&lang=js&"
export * from "./init.vue?vue&type=script&lang=js&"
import style0 from "./init.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e230ed44')) {
      api.createRecord('e230ed44', component.options)
    } else {
      api.reload('e230ed44', component.options)
    }
    module.hot.accept("./init.vue?vue&type=template&id=e230ed44&", function () {
      api.rerender('e230ed44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/init/init.vue"
export default component.exports